import React, { useEffect, useState, useRef } from 'react';
import Mapka from "~/assets/mapka.png";
import KrysaImg from "~/assets/krysa.jpg";
import "./style.less";

const KRYSA_COORDS = {
	lon: 17.1529560,
	lat: 49.0351832,
};
const ZOOM = 13;

export default function MapPage() {
	const [mapIsLoaded, setMapLoaded] = useState(false);
	const mapEl = useRef(null);

	window.mapLoadProm.then(() => {
		setMapLoaded(true);
	});

	useEffect(() => {
		if (mapIsLoaded) {
			const center = SMap.Coords.fromWGS84(KRYSA_COORDS.lon, KRYSA_COORDS.lat);
			const map = new SMap(mapEl.current, center, ZOOM);

			map.addDefaultLayer(SMap.DEF_BASE).enable();
			map.addDefaultControls();

			const layer = new SMap.Layer.Marker();

			map.addLayer(layer);
			layer.enable();

			const options = {};
			const marker = new SMap.Marker(center, "myMarker", options);

			layer.addMarker(marker);
		}
	}, [mapIsLoaded]);

	return <div className="mapPage">
		<h2 className="mapPage__title">Mapa</h2>
		<p>GPX lon = <strong>{KRYSA_COORDS.lon}</strong>, lat = <strong>{KRYSA_COORDS.lat}</strong></p>
		<p className="mainPage__alignToCenter">
			<img src={KrysaImg} alt="Vinařství Krýsa" className="mapPage__krysa" />
		</p>
		<p>
			<img src={Mapka} alt="Mapka vinařství" className="mapPage__planek" />
		</p>
		<p>
			<a href="https://mapy.cz/zakladni?x=17.1519394&y=49.0351540&z=19&source=firm&id=12945930" target="_blank" rel="noreferrer">Odkaz na mapy.cz</a>
		</p>
		<div id="m" className="mapPage__map" ref={mapEl}></div>
	</div>;
}
